import { createFileRoute, redirect } from "@tanstack/react-router";

// Compliance moved to /fundraising-settings?section=compliance (under the
// Settings tab bar) as part of the Your Donors IA refactor. Keep this route
// as a permanent redirect so existing deep links and bookmarks don't 404.
export const Route = createFileRoute("/_app/_/fundraising/compliance")({
	beforeLoad: () => {
		throw redirect({
			to: "/fundraising-settings",
			search: { section: "compliance" },
		});
	},
});
